"use client";

import Image from "next/legacy/image";
import * as React from "react";
import { cn } from "@/lib/utils";
import { homeCardVariants } from "../foundations/home-variants";

export interface HomeRoleStatCardV2Props {
  title: string;
  subtitle?: string;
  value: number;
  avatar?: string;
}

export function HomeRoleStatCardV2({
  title,
  subtitle,
  value,
  avatar
}: HomeRoleStatCardV2Props) {
  return (
    <div className={cn(homeCardVariants({ variant: "metric" }), "min-h-[110px] border-2 p-3")}>
      <div className="flex h-full flex-col items-center justify-center gap-1">
        <div className="relative">
          <Image
            src={avatar || "/images/jobs/base.png"}
            alt="avatar"
            width={57}
            height={57}
            unoptimized
            className="rounded-full"
          />
          <div className="absolute bottom-1 right-1 flex h-5 w-5 items-center justify-center rounded-full bg-purple-300 text-xs font-bold dark:bg-violet-500">
            {value}
          </div>
        </div>
        <div>
          <span className="block text-center text-xs text-slate-700 dark:text-zinc-100">{title}</span>
          <span className="block text-center text-xs capitalize text-purple-500 dark:text-zinc-400">
            {subtitle}
          </span>
        </div>
      </div>
    </div>
  );
}
